module.exports = __webpack_public_path__ + "media/images/dooh_1920x1080-9f9261c3.svg";